/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum indicating types of pets.
 */
export enum HousingPetFriendlyTypes {
    NONE = 'None',
    DOG = 'Dog',
    CAT = 'Cat',
    BOTH = 'Both',
}
